import { useHistory } from 'react-router-dom'
import PageHeader from "../../components/layout/PageHeader.jsx";
import SelectableGrid from "../../components/common/SelectableGrid.jsx";
import Location from "../../hooks/Location";
import { client } from "../../hooks/Client";
import useImpactPerEuroRatio from "../../hooks/useImpactPerEuroRatio";
import OverviewTab from "../../components/impactinbeeld/tabs/OverviewTab.jsx";
import ChannelsTab from "../../components/impactinbeeld/tabs/ChannelsTab.jsx";
import ProductsTab from "../../components/impactinbeeld/tabs/ProductsTab.jsx";
import HuisstijlTab from "../../components/impactinbeeld/tabs/HuisstijlTab.jsx";
import IntegrationsTab from "../../components/impactinbeeld/tabs/IntegrationsTab.jsx";

/**
 * @typedef {object} HubTab
 * @property {string} id - URL segment and stable identifier of the tab
 * @property {string} label - Tab label shown in the tab strip
 */

/** @type {Array<HubTab>} */
const hubTabs = [
    { id: 'overzicht', label: 'Overzicht' },
    { id: 'kanalen', label: 'Kanalen' },
    { id: 'producten', label: 'Producten & diensten' },
    { id: 'huisstijl', label: 'Huisstijl' },
    { id: 'integraties', label: 'Integraties' },
]

/**
 * "Impact in beeld" hub: vijf URL-gedreven tabs (Overzicht / Kanalen /
 * Producten & diensten / Huisstijl / Integraties) op
 * /:client/impactinbeeld/:tab? — onbekend segment valt terug op Overzicht.
 * See docs/features/impact-in-beeld-hub.md.
 */
const ImpactInBeeld = () => {
    const history = useHistory()

    // Eén keer op hub-niveau: de MSI-recordketen achter deze hook is duur en
    // zou anders bij elke tab-wissel opnieuw fetchen (remount). Tabs krijgen
    // het resultaat als prop. AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
    const impactPerEuro = useImpactPerEuroRatio()

    const tabFromUrl = Location()[3]
    const activeTabId = hubTabs.some(tab => tab.id === tabFromUrl) ? tabFromUrl : 'overzicht'

    const selectTab = (tabId) => {
        history.push(`/${client}/impactinbeeld/${tabId}`)
    }

    return (
        <div className="main">
            <div className="main-container">
                <PageHeader
                    heading={'Impact in beeld'}
                    description={'Laat klanten direct zien welke maatschappelijke waarde zij helpen mogelijk maken op de plekken waar zij jouw organisatie ontmoeten: in je restaurant, winkel, website, kassabon, offerte en meer.'}
                    AI={false}
                />
                <SelectableGrid
                    items={hubTabs}
                    getId={(tab) => tab.id}
                    getLabel={(tab) => tab.label}
                    selectedId={activeTabId}
                    onClick={selectTab}
                />
                {activeTabId === 'overzicht' && <OverviewTab impactPerEuro={impactPerEuro} />}
                {activeTabId === 'kanalen' && <ChannelsTab impactPerEuro={impactPerEuro} />}
                {activeTabId === 'producten' && <ProductsTab impactPerEuro={impactPerEuro} />}
                {activeTabId === 'huisstijl' && <HuisstijlTab />}
                {activeTabId === 'integraties' && <IntegrationsTab />}
            </div>
        </div>
    )
}

export default ImpactInBeeld
